import { render } from "./ConnectACHPage.vue?vue&type=template&id=21c5734d"
import script from "./ConnectACHPage.vue?vue&type=script&lang=js"
export * from "./ConnectACHPage.vue?vue&type=script&lang=js"
script.render = render

export default script